import React from "react";
import { Link, useLocation } from "react-router-dom";

interface DesktopNavProps {
  items: { path: string; label: string }[];
}

const DesktopNav: React.FC<DesktopNavProps> = ({ items }) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="hidden md:flex items-center gap-1 lg:gap-2">
      {items.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={`
            relative px-4 py-2 text-sm font-medium rounded-lg
            transition-all duration-300 ease-out
            ${isActive(item.path)
              ? "text-primary bg-white/10 backdrop-blur-sm shadow-sm"
              : "text-white/80 hover:text-white hover:bg-white/5"
            }
          `}
        >
          {item.label}
          
          {/* Indicateur actif : ligne lumineuse sous le lien */}
          <span
            className={`
              absolute -bottom-1 left-1/2 w-6 h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full
              transition-all duration-300 ease-out
              ${isActive(item.path) 
                ? "opacity-100 translate-x-[-50%]" 
                : "opacity-0 group-hover:opacity-70 group-hover:w-4 group-hover:translate-x-[-50%]"
              }
            `}
          />
        </Link>
      ))}
    </nav>
  );
};

export default DesktopNav;